import { render, staticRenderFns } from "./govNewsDetails.vue?vue&type=template&id=70a8dd46&scoped=true"
import script from "./govNewsDetails.vue?vue&type=script&lang=js"
export * from "./govNewsDetails.vue?vue&type=script&lang=js"
import style0 from "./govNewsDetails.vue?vue&type=style&index=0&id=70a8dd46&prod&lang=scss"
import style1 from "./govNewsDetails.vue?vue&type=style&index=1&id=70a8dd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a8dd46",
  null
  
)

export default component.exports